module.exports = __webpack_public_path__ + "static/media/l-trapp-vanster.df3819fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/l-trapp-vanster.png
// module id = 41
// module chunks = 0